.container {
    letter-spacing: 0.5px;
    color: var(--grey-lt);
}
